import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { modulesActions } from '../actions/modules.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class ModulesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getModules$ = createEffect(() => {
        return this.actions.pipe(
            ofType(modulesActions.getModules),
            mergeMap(({ value }) => {
                return this.httpService.getModules(value).pipe(
                    finalizeLoader('modules-list'),
                    map(({ payload, total }) => modulesActions.getModulesSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(modulesActions.getModulesError({ code: response.status }))),
                );
            }),
        );
    });
}
